module.exports = __webpack_public_path__ + "img/clock.857de498.png";